import { Component, OnInit } from '@angular/core';
import { UsefulLink } from './useful-link';
import { UsefulLinksService } from './useful-links.service';
import { GoogleAnalyticsUtils } from '../../../classes/static/google-analytics-utils';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'useful-links',
	template: require('./useful-links.component.html'),
})
export class UserfulLinksComponent implements OnInit {
	links: UsefulLink[] = new UsefulLinksService().links;
	socialLinks: UsefulLink[] = new UsefulLinksService().socialLinks;
	leftLinks: UsefulLink[] = [];
	rightLinks: UsefulLink[] = [];
	public isRebrading = AppSettings.isRebrading;

	constructor() {}
	ngOnInit() {
		this.leftLinks = this.links.slice(0, 4);
		this.rightLinks = this.links.slice(4, 8);
	}

	sendSocialAnalytics(socialNetwork: string) {
		switch (socialNetwork) {
			case 'facebook': {
				GoogleAnalyticsUtils.sendSocialNetworkFb();
				break;
			}
			case 'twitter': {
				GoogleAnalyticsUtils.sendSocialNetworkTwitter();
				break;
			}
			case 'youtube': {
				GoogleAnalyticsUtils.sendSocialNetworkYouTube();
				break;
			}
			case 'mail': {
				GoogleAnalyticsUtils.sendSocialNetworkMail();
				break;
			}
			case 'linkedin': {
				GoogleAnalyticsUtils.sendSocialNetworkLinkedIn();
				break;
			}
			default: {
				break;
			}
		}
	}
}
